var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#7043FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7047 29.4206C21.5728 29.4206 21.4437 29.3834 21.332 29.3135C21.2203 29.2435 21.1304 29.1436 21.0728 29.025L17.7681 22.2314L10.9745 18.9272C10.8521 18.8675 10.7497 18.7736 10.6797 18.6569C10.6096 18.5402 10.575 18.4056 10.5799 18.2695C10.5849 18.1335 10.6293 18.0018 10.7076 17.8905C10.786 17.7791 10.895 17.6929 11.0214 17.6424L28.4547 10.6303C28.5826 10.5788 28.7228 10.566 28.858 10.5935C28.9931 10.6211 29.1172 10.6878 29.2147 10.7853C29.3122 10.8828 29.3789 11.0069 29.4065 11.142C29.434 11.2771 29.4212 11.4174 29.3697 11.5453L22.3572 28.98C22.3063 29.1063 22.2199 29.2151 22.1084 29.2933C21.9969 29.3714 21.8651 29.4155 21.729 29.4202L21.7047 29.4206ZM13.015 18.3581L18.6015 21.0769C18.7431 21.1457 18.8575 21.2601 18.9264 21.4017L21.6451 26.9883L27.4478 12.5485L13.015 18.3581Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.294 22.4086C18.155 22.4086 18.019 22.3673 17.9034 22.29C17.7878 22.2127 17.6977 22.1029 17.6445 21.9744C17.5913 21.8459 17.5774 21.7045 17.6046 21.5681C17.6318 21.4317 17.6988 21.3064 17.7972 21.2081L28.2198 10.7855C28.2851 10.7202 28.3627 10.6684 28.448 10.6331C28.5333 10.5978 28.6248 10.5796 28.7171 10.5796C28.8094 10.5797 28.9009 10.5979 28.9862 10.6332C29.0715 10.6686 29.1494 10.72 29.2147 10.7853C29.28 10.8506 29.3313 10.9286 29.3667 11.0139C29.402 11.0992 29.4201 11.1906 29.4201 11.283C29.4201 11.3753 29.4019 11.4668 29.3665 11.5521C29.3312 11.6374 29.2794 11.7149 29.214 11.7802L18.7914 22.2047C18.6592 22.3359 18.4803 22.4092 18.294 22.4086Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepSendMessage);
export default __webpack_public_path__ + "static/media/step_send_message.f83828e79d8cd8b5391eb3f3c8e64cd9.svg";
export { ForwardRef as ReactComponent };